import { createNavigationContainerRef } from '@react-navigation/native';

// Top-level navigation ref for imperative navigation outside the React tree.
export const navigationRef = createNavigationContainerRef();
